import { render, staticRenderFns } from "./emailVerification.vue?vue&type=template&id=94d1859e&scoped=true&"
import script from "./emailVerification.vue?vue&type=script&lang=js&"
export * from "./emailVerification.vue?vue&type=script&lang=js&"
import style0 from "./emailVerification.vue?vue&type=style&index=0&id=94d1859e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d1859e",
  null
  
)

export default component.exports